'use strict';

import React from 'react'

import TextEditor from '@/Form/toolkit/TextEditor'

import { HuePicker as ColorPicker }              from 'react-color'
import { TwitterPicker as ColorPickerSecondary } from 'react-color'

let app = window.app;

export default class FormElement extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { id: ++app.form_index };

		this.getElementFromType = this.getElementFromType.bind(this);
		this.handleColorChange  = this.handleColorChange.bind(this);
		this.handleChange       = this.handleChange.bind(this);
	}

	componentDidMount ()
	{
		var component = this, props = this.props;

		var data =
		{
			value: props.data[props.name] || props.defaultValue || '',
			name: props.name
		};

		if (props.type === 'radio' && props.checked === true)
		{
			data.value = props.data[props.name] || props.radio_value;
		}

		if (props.type === 'checkbox')
		{
			let defaultValue = [true, 'true'].indexOf(props.defaultValue) !== -1;
			let value        = [true, 'true'].indexOf(props.data[props.name]) !== -1;

			data.value = props.data[props.name] ? value : defaultValue;
		}
		else if (props.type === 'date')
		{
			let defaultValue = props.data[props.name] || '';

			if (props.defaultValue)
			{
				defaultValue = props.defaultValue;
			}

			data.value = defaultValue;
		}

		if (typeof props.onChange === 'function') props.onChange(null, data);
	}

	getElementFromType (value)
	{
		var component = this, props = this.props;
		var element, class_name, type = props.type;

		class_name = 'c-form__input';

		if (type === 'checkbox')
		{
			class_name = 'c-form__checkbox';
		}
		else if (type === 'textarea')
		{
			class_name = 'c-form__textarea';
		}
		else if (type === 'radio')
		{
			class_name = 'c-form__radio';
		}
		else if (type === 'colorPicker')
		{
			class_name = 'c-form__color-picker';
		}

		if (props.editable === true)
		{
			class_name += ' c-form__input-editable';
		}

		if (type === 'date' && typeof app.state.ie === 'undefined')
		{
			if (value !== '')
			{
				let date = window.moment(value);

				if (date.isValid() === true)
				{
					value = window.moment(value).format('YYYY-MM-DD');
				}
			}
		}

		if (type === 'textarea')
		{
			element =
			(
				<textarea className={ class_name } name={ props.name }
					onChange={ component.handleChange }
					value={ value }
					id={ (props.id_prefix || '') + component.state.id }
					placeholder={ props.placeholder }
					style={ { minHeight: props.minHeight } }
					readOnly={ props.readOnly || false } >
				</textarea>
			);
		}
		else if (type === 'select')
		{
			element =
			(
				<select className={ class_name } name={ props.name }
					onChange={ component.handleChange }
					readOnly={ props.readOnly || false }
					value={ value }
					id={ (props.id_prefix || '') + component.state.id }>
					<option value=""></option>
					{ props.children }
				</select>
			);
		}
		else if (type === 'checkbox')
		{
			if (value === 'false') value = false;

			element =
			(
				<input className={ class_name } name={ props.name }
					onChange={ component.handleChange }
					readOnly={ props.readOnly || false }
					disabled={ props.readOnly || false }
					spellCheck={ false } checked={ Boolean(value) }
					type={ type } id={ (props.id_prefix || '') + component.state.id }
					autoComplete={ props.autoComplete || undefined } />
			);
		}
		else if (type === 'editor')
		{
			element =
			(
				<TextEditor onChange={ component.handleChange } value={ value }
					name={ props.name } images={ props.images }
					color={ props.color }
				/>
			);
		}
		else if (type === 'colorPicker')
		{
			element =
			(
				<div className={ class_name }>
					<ColorPicker color={ value }
						onChangeComplete={ component.handleColorChange } />

					<ColorPickerSecondary color={ value }
						onChangeComplete={ component.handleColorChange } />
				</div>
			);
		}
		else
		{
			if (props.valueHook instanceof Function)
			{
				value = props.valueHook(value, props.data, props.name);
			}

			element =
			(
				<input className={ class_name } name={ props.name }
					onChange={ component.handleChange }
					type={ type } value={ value }
					id={ (props.id_prefix || '') + component.state.id }
					min={ props.min } max={ props.max }
					step={ props.step } spellCheck={ false }
					autoComplete={ props.autoComplete || undefined }
					checked={ value === props.radio_value ? true : false }
					placeholder={ props.placeholder }
					readOnly={ props.readOnly || false }
					disabled={ props.readOnly || false }
				/>
			);
		}

		return element;
	}

	handleColorChange (color, e)
	{
		const component = this, props = this.props;

		let data =
		{
			value: color.hex,
			name: props.name
		};

		if (typeof props.onChange === 'function') props.onChange(e, data);
	}

	handleChange (e)
	{
		const component = this, props = this.props;

		let data =
		{
			value: typeof e === 'string' ? e : e.target.value,
			name: props.name
		};

		if (props.type === 'radio')
		{
			data.value = props.radio_value;
		}

		if (props.type === 'checkbox')
		{
			data.value = e.target.checked;
		}

		if (typeof props.onChange === 'function')
		{
			if (typeof e === 'string')
			{
				data.type = 'editor';

				props.onChange(null, data);
			}
			else
			{
				props.onChange(e, data);
			}
		}
	}

	render ()
	{
		var component = this, props = this.props;
		var label, element, type, warning, error, info, indicator;

		var class_name = props.className || 'c-form-element';

		class_name += ' c-form-element--' + props.type;

		if (props.inline === true)
		{
			class_name += ' c-form-element--inline';
		}

		var status = (props.status || { })[props.name] || { };
		var value  = props.data[props.name] || '';

		let front_indicator =
		(
			<svg className="o-svg-icon o-svg-icon--eye c-form-label__icon">
				<use xlinkHref="/images/icons.svg#svg-icon-eye"></use>
			</svg>
		);

		if (props.front_indicator !== true)
		{
			front_indicator = undefined;
		}

		const required_indicator = props.required === true ?
		(
			<span className="c-form-label__requied-indicator" />
		)
		: undefined;

		if (props.label)
		{
			label =
			(
				<label className={ 'c-form-label' + ' c-form-label--' + props.type }
					htmlFor={ (props.id_prefix || '') + component.state.id }>
					{ front_indicator }
					{ props.label }
					{ required_indicator }
				</label>
			);
		}

		if (props.type === 'checkbox')
		{
			indicator =
			(
				<label className="c-form__checkbox-indicator" title={ props.title }
					htmlFor={ (props.id_prefix || '') + component.state.id }></label>
			);
		}

		if (props.type === 'radio')
		{
			indicator =
			(
				<label className="c-form__radio-indicator"
					htmlFor={ (props.id_prefix || '') + component.state.id }></label>
			);
		}

		if (status.info)
		{
			info =
			(
				<div className="c-form-label c-form-label--info">
					{ status.info }
				</div>
			);

			class_name += ' c-form-element--info';
		}

		if (status.warning)
		{
			warning =
			(
				<div className="c-form-label c-form-label--warning">
					{ status.warning }
				</div>
			);

			class_name += ' c-form-element--warning';
		}

		if (status.error)
		{
			error =
			(
				<div className="c-form-label c-form-label--error">
					{ status.error }
				</div>
			);

			class_name += ' c-form-element--error';
		}

		element = component.getElementFromType(value);

		if (props.column === true)
		{
			class_name += ' c-form-element--column';
		}

		var output;

		output =
		(
			<div className={ class_name }>

				{ label }

				{ warning }

				{ error }

				{ info }

				{ element }

				{ indicator }

				{ props.type !== 'select' ? props.children : undefined }

			</div>
		);

		if (props.inline === true)
		{
			output =
			(
				<div className={ class_name }>

					{ warning }

					{ error }

					{ info }

					{ label }

					<div className="c-form__input-container">
						{ element }

						{ indicator }
					</div>

				</div>
			);
		}

		return (props.type === 'hidden' && !props.label) ? element : output;
	}
}